const state = {
  monday: [],
  tuesday: [],
  wednesday: [],
  thursday: [],
  friday: [],
}

export default state
